import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

import palette from './palette';
import typography from './typography';

// Create theme
const theme = createTheme({
  palette,
  typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      xxl: 1800,
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '50px',
          boxShadow: 'none',
          fontSize: typography.button.large.fontSize,
          fontWeight: typography.button.large.fontWeight,
          border: `2px solid ${palette.primary.main}`,
          '&:hover': {
            boxShadow: 'none',
          },
          padding: '10px 16px',
        },
        contained: {
          backgroundColor: palette.primary.main,
          color: palette.text.onSurface,
          '&:hover': {
            backgroundColor: palette.primary.clicked,
            borderColor: palette.primary.clicked,
            color: palette.text.contrast,
          },
          '&:disabled': {
            border: 'none',
          },
        },
        outlined: {
          color: palette.primary.main,
          border: `1px solid ${palette.primary.main}`,
        },
        text: {
          border: 'none',
          fontWeight: 400,
          color: palette.text.secondary,
        },
        sizeLarge: {
          fontSize: typography.button.large.fontSize,
          fontWeight: typography.button.large.fontWeight,
        },
        sizeMedium: {
          fontSize: typography.button.medium.fontSize,
          fontWeight: typography.button.medium.fontWeight,
        },
        sizeSmall: {
          fontSize: typography.button.small.fontSize,
          fontWeight: typography.button.small.fontWeight,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '0.5rem 1rem',
          backgroundColor: palette.surface.lighter,
          borderRadius: '10px',
          boxShadow: 'none',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          '.MuiInputBase-root': { backgroundColor: palette.surface.white },
          '.MuiTableBody-root>.MuiTableRow-root:not(:last-child)>.MuiTableCell-root, .MuiTableHead-root>.MuiTableRow-root:first-of-type>.MuiTableCell-root':
            {
              borderTop: `1px solid ${palette.surface.lightest}`,
              borderBottom: `1px solid ${palette.surface.lightest}`,
            },
          '.MuiTableBody-root>.MuiTableRow-root:last-child>.MuiTableCell-root': {
            borderBottom: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root.Mui-disabled': {
            backgroundColor: 'transparent',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: `${palette.surface.light}`,
            },
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
        },
      },
    },
  },
});

export default theme;
